import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  CreateDoRequestActionOutput,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE = 'REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE'
export const doREQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE =
  createDoRequestAction<RequestParticipantCompleteStatusUpdatePayload>(REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE)

export const requestParticipantCompleteStatusUpdateActionCreators = {
  doREQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE,
}

export type RequestParticipantCompleteStatusUpdatePayload =
  | {
      participantId: string
      complete: true
      force: boolean
    }
  | {
      participantId: string
      complete: false
    }

const requestParticipantCompleteStatusUpdateSchema = v.alternatives(
  v.object({
    requestId: v.string().uuid().exist(),
    participantId: v.string().uuid().exist(),
    complete: v.boolean().valid(true).exist(),
    force: v.boolean().exist(),
  }),
  v.object({
    requestId: v.string().uuid().exist(),
    participantId: v.string().uuid().exist(),
    complete: v.boolean().valid(false).exist(),
  }),
)

export function* requestParticipantCompleteStatusUpdate({
  payload,
  setRequestResult,
}: CreateDoRequestActionOutput<RequestParticipantCompleteStatusUpdatePayload>): SagaIterator {
  debug('saga*requestParticipantCompleteStatusUpdate')

  try {
    assertTotalSchema({
      payload,
      schema: requestParticipantCompleteStatusUpdateSchema,
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const accessToken = yield call(getToken)
  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/participant-complete-status-update`,
    accessToken,
    data: payload.complete
      ? {
          participantId: payload.participantId,
          complete: true,
          force: payload.force,
        }
      : {
          participantId: payload.participantId,
          complete: false,
        },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/participant-complete-status-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantCompleteStatusUpdateSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_COMPLETE_STATUS_UPDATE, requestParticipantCompleteStatusUpdate)
}
